import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.AbsenceCreate.title',
    defaultMessage: 'Register Absence',
  },
  saveSuccess: {
    id: 'app.containers.AbsenceCreate.saveSuccess',
    defaultMessage: 'Absence has been successfully registered.',
  },
  saveFailure: {
    id: 'app.containers.AbsenceCreate.saveFailure',
    defaultMessage: 'Error. The absence could not be registered.',
  },
});
